module.exports = __webpack_public_path__ + "static/media/AppGallery_Badge_de.2c93d326.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AppGallery_Badge_de.svg
// module id = 669
// module chunks = 21